import React from 'react';
import {Slide, Zoom } from 'react-awesome-reveal'
import AZ from '../../assets/logos/logo2.png'
import { Link } from 'react-router-dom';

const BannerCultureTour = () => {
  return (
    <div
      id="banner-area"
      className="banner-area  p-5"
      style={{ backgroundImage: "url(images/assets/ban6.jpg)",height:'620px' }}
    >
      <div className="banner-text">
        <div className="container">
           <div className="particles">
              {[...Array(20)].map((_, i) => (
                <div 
                  key={i}
                  className="particle"
                  style={{
                    width: `${Math.random() * 10 + 2}px`,
                    height: `${Math.random() * 10 + 2}px`,
                    top: `${Math.random() * 100}%`,
                    left: `${Math.random() * 100}%`,
                    animationDelay: `${Math.random() * 5}s`,
                    animationDuration: `${Math.random() * 10 + 5}s`
                  }}
                />
              ))}
            </div>
             <div className="text-center mb-3">
                      <Zoom>
                        <img src={AZ} alt="logo" className="img-fluid mb-2 mt-5" style={{ maxWidth: 200}} />
                      </Zoom>
                    
                    </div>
          <div className="row">
            <div className="col-lg-12">
              <div className="banner-heading">
                <Zoom>
                <h1 className="banner-title">Transport sécurisé </h1>
                </Zoom>  
                <nav aria-label="breadcrumb">
                <Slide direction="left">
                  <ol className="breadcrumb justify-content-center text-dark">
                    <li className="breadcrumb-item  text-dark">
                      <Link className='text-dark' to="/">Accueil</Link>
                    </li>
                    <li className="breadcrumb-item">
                      <Link style={{color:'#000'}} to="/about"> Qui Sommes-Nous</Link>
                    </li>
                    <li className="breadcrumb-item">
                      <Link style={{color:'#000'}} to="/Services"> Nos Services</Link>
                    </li>
                    <li className="breadcrumb-item active" aria-current="page">
                Transport sécurisé
                    </li>
                  </ol>
                  </Slide>
                </nav>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BannerCultureTour;
